/** Vite 8 build/dev can expose a Babel CommonJS module object where Vitest
 * supplies its default directly; both packages can add one `.default` layer. */
export function babelModuleDefault<T>(value: T | { default: T }): T {
  return value !== null && typeof value === 'object' && 'default' in value
    ? value.default
    : value;
}
